<template>
  <section class="section section--elevated">
    <LazyBg :src="bgSrc" />
    <div class="container">
      <h2 class="section-title">万卡级异构算力集群架构</h2>
      <p class="section-lead">融合裸金属、容器与虚拟机，实现全栈异构资源的统一纳管与故障隔离</p>
      <div class="features-grid features-grid--quad">
        <div v-for="a in arch" :key="a.title" class="feature-card">
          <div class="feature-icon" v-html="a.icon" />
          <h3>{{ a.title }}</h3>
          <p>{{ a.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import bgSrc from '@/assets/AI_bg2.jpg';
import LazyBg from '@/components/LazyBg.vue';
const arch = [{
  title: '极速互联网络',
  desc: 'Spine-Leaf 无损网络，200G/400G 全线速高速互联。GPUDirect RDMA (GDR) 零拷贝技术，时延低至微秒级。多路径冗余与智能化网络拥塞控制 (PFC+ECN)。',
  icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="5" cy="12" r="2"/><circle cx="19" cy="5" r="2"/><circle cx="19" cy="19" r="2"/><path d="M7 12h4l3-5 3 10"/></svg>'
}, {
  title: '高性能物理底座',
  desc: '高性能 GPU 裸金属物理节点，多卡高速 NVLink 连接。分布式高性能 NVMe 存储集群，千万级超高 IOPS 读写。风冷、液冷、绿色节能定制机柜。',
  icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M9 9h6M9 12h6M9 15h3"/><path d="M4 9h-1M4 15h-1M21 9h1M21 15h1"/></svg>'
}, {
  title: '智能调度算法',
  desc: '智能算力切片与动态拓扑感知调度算法，大模型一键式微调、部署与 API 托管服务，实现多任务智能分配与高速流转。',
  icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/></svg>'
},
{
  title: '算力编排引擎',
  desc: 'Kubernetes + KubeVirt 双引擎算力统一编排，Slurm 高性能计算作业批处理及混合调度，物理级硬件安全隔离与多租户隔离防护体系。',
  icon: '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/><path d="M7 8h2M7 12h4M15 8h2M15 12h2"/></svg>'
}



];
</script>
<style scoped lang="scss">
.container {
  position: relative;
  z-index: 1;
}

 .section {
  /* bg via LazyBg */
}
</style>